module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAMZJREFUOE+V000KwjAQBeCZWsQb6BFEqtUbKBgQXGvxhKKuXUXQvQstFvEIeoWqGUkXpTXNT7N+XwgvPISaB2V+wKMzAvlfbMyS6fpluiMDIY9ugBAQwUOgNzahDPT2i47f9I6I0LWhDNRBOXBFJeCCFGBDlcCEtOAfAUESs03fCILDqu2ROMm6gegas+1IC4ph+TefVEzu892zEujC8pkKMIUVYAuXgEs4B67hHIR8eQHEYbEN3SYKA4LWOxVMVmcdUJ2V/gDcr7YVDyMU+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img21.png
// module id = OwE3
// module chunks = 1